// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import RefreshCcw from "@insite/mobius/Icons/RefreshCcw";
import RotateCcw from "@insite/mobius/Icons/RotateCcw";
import X from "@insite/mobius/Icons/X";
import { orderDetailsButtonSetStyles } from "@steiner/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";
import Mail from "@steiner/XDL/Icons/Mail";
import Plus from "@steiner/XDL/Icons/Plus";
import Print from "@steiner/XDL/Icons/Print";
import { css } from "styled-components";

orderDetailsButtonSetStyles.printButton = {
    variant: "link" as any,
    mergeCss: true,
    sizeVariant: "small",
    icon: {
        src: Print,
        position: "left",
    },
};

orderDetailsButtonSetStyles.shareEntityButtonStyles = {
    button: {
        variant: "link" as any,
        mergeCss: true,
        icon: {
            src: Mail,
            position: "left",
        },
        sizeVariant: "small",
        color: "primary",
    },
};

orderDetailsButtonSetStyles.reorderButton = {
    css: css`
        width: 100%;
    `,
};


orderDetailsButtonSetStyles.reorderingButton = {
    // variant: "secondary" as any,
    mergeCss: true,
    sizeVariant: "small",
    css: css`
        display: flex;
        align-items: center;
        margin-top: 7px;
    `,
};

orderDetailsButtonSetStyles.rmaButton = {
    variant: "link" as any,
    mergeCss: true,
    icon: {
        src: RefreshCcw,
        position: "left",
    },
    sizeVariant: "small",
};

orderDetailsButtonSetStyles.cancelButton = {
    variant: "link" as any,
    mergeCss: true,
    icon: {
        src: X,
        position: "left",
    },
    sizeVariant: "small",
};

orderDetailsButtonSetStyles.addAllProductGroupButton = {
    variant: "link" as any,
    mergeCss: true,
    icon: {
        src: Plus,
        position: "left",
    },
    sizeVariant: "small",
};

orderDetailsButtonSetStyles.spinner = {
    size: 14,
    css: css`
        margin: 0;
        margin-right: 4px;
    `,
};

orderDetailsButtonSetStyles.buttonsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px 24px;
    `,
};

orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        margin: 0;
    `,
};

orderDetailsButtonSetStyles.toasterMessage = {
    css: css`
        display: flex;
        align-items: center;
        a span {
            font-size: 15px;
        }
    `,
};

orderDetailsButtonSetStyles.twoButtonModalStyles = {};
